import styled from '@emotion/styled'
import { IconButton, type IconButtonProps } from '@mui/material'

import { lightTheme } from '~createTheme'

interface StyledIconButtonProps extends IconButtonProps {
  iconColor?: string
  square?: string
  showOutline?: boolean
}

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => {
    return prop !== 'iconColor' && prop !== 'square' && prop !== 'showOutline'
  },
})<StyledIconButtonProps>(({ iconColor, square, showOutline = true }) => {
  return {
    color: iconColor || lightTheme.palette.text.disabled,
    boxShadow: showOutline ? '1px 1px 8px 0px rgba(231, 231, 231, 1)' : '',
    '&:active': {
      boxShadow: 'none',
      transform: 'scale(0.90)',
    },
    height: square || 'auto',
    width: square || 'auto',
  }
})

export default StyledIconButton
